<mat-icon class="dynamic-icon" matTooltip="{{iconTooltip}}">{{matIconName}}</mat-icon>